import * as types from './mutationTypes'
const matutions = {
  // 设置 login
  [types.SET_ROUTE_INFO](state, data) {
    state.routeInfo = data
  },
  // 设置全局状态
  [types.SET_GLOBAL_STATUS](state, data) {
    state.globalStatus[data.target] = data.value
  },
  // 设置 wpsUrl
  [types.SET_WPS_URL](state, data) {
    state.wpsUrl = data
  },
  // 设置系统权限
  [types.SET_SYSTEM_PERM](state, data) {
    state.systemPerm = data
  },
  // 设置日志 id 标识
  [types.SET_OPERATION_ID](state, data) {
    state.operationId = data
  },
  //设置orgListByUser
  [types.SET_ORG_LIST](state, data) {
    state.orgListByUser = data
  }
}
export default matutions



// WEBPACK FOOTER //
// ./src/store/mutations.js